import axios from 'axios'
import CustomButton from 'components/Buttons/CustomButton'
import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import Select from 'react-select'
import SelectInputWithTestId from 'components/PMBSelect/SelectInputWithTestId'
import { Form, FormGroup, Input, Label, Modal, ModalBody } from 'reactstrap'
import { apiEndpoint } from '../../utility/Utils'

const ModalUnverifSeller = ({
  isOpen,
  toggle,
  handleFinished,
  selectedContact,
}) => {
  const { token } = useSelector((e) => e.auth)
  const [dataSeller, setDataSeller] = useState({})
  const [dataBank, setDataBank] = useState([])

  const handleChange = (key, e) => {
    setDataSeller((prevValues) => ({
      ...prevValues,
      [key]: e,
    }))
  }

  const getBank = async () => {
    try {
      const { data } = await axios.get(`${apiEndpoint}/api/v1/bussines/bank`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      const newData = data?.data?.map((e) => {
        return {
          label: e.code,
          value: e.code,
          logo: e.logo,
          code: e.code,
        }
      })
      setDataBank(newData)
    } catch {
      // Error fetching bank data
    }
  }

  useEffect(() => {
    if (isOpen) {
      getBank()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen])

  useEffect(() => {
    if (selectedContact && selectedContact?.relationName) {
      setDataSeller({
        fullName: selectedContact?.relationName ?? '',
      })
    }
  }, [selectedContact])

  return (
    <Modal className="p-5 w-100" isOpen={isOpen} toggle={toggle} centered data-testid="transaction-unverified-seller-modal">
      <ModalBody className="w-100">
        <h5 className="fw-bold">Nomor belum terdaftar</h5>
        <p>
          Nomor handphone yang Anda masukkan belum terdaftar di PasarMIKRO.
          Tambahkan data secara manual untuk melanjutkan transaksi.
        </p>
        <Form className="w-100">
          <FormGroup>
            <Label>Nama penjual</Label>
            <Input
              placeholder="Masukkan nama"
              type="text"
              name="fullName"
              value={dataSeller?.fullName}
              onChange={(e) => {
                handleChange(e.target.name, e.target.value)
              }}
            />
          </FormGroup>
          <FormGroup>
            <Label>Bank</Label>
            <Select
              placeholder="Pilih bank"
              value={dataSeller?.bankData}
              options={dataBank}
              onChange={(e) => {
                handleChange('bankData', e)
              }}
              components={{ Input: SelectInputWithTestId }}
              data-testid="transaction-bank-select"
            />
          </FormGroup>
          <FormGroup>
            <Label>Nomor rekening</Label>
            <Input
              placeholder="Masukkan nomor rekening"
              type="number"
              name="bankAccountNumber"
              value={dataSeller?.bankAccountNumber}
              onChange={(e) => {
                handleChange(e.target.name, e.target.value)
              }}
            />
          </FormGroup>
          <FormGroup>
            <Label>Nama pemilik rekening</Label>
            <Input
              placeholder="Masukkan nama pemilik rekening"
              type="text"
              name="bankAccountName"
              value={dataSeller?.bankAccountName}
              onChange={(e) => {
                handleChange(e.target.name, e.target.value)
              }}
            />
          </FormGroup>
          <div className="d-flex justify-content-between gap-2">
            <CustomButton
              onClick={() => {
                toggle()
                setDataSeller({})
              }}
              className="flex-grow-1 btn-cancel"
              outline
              block
              color="secondary"
            >
              Batal
            </CustomButton>
            <CustomButton
              disabled={
                !dataSeller?.fullName ||
                !dataSeller?.bankData ||
                !dataSeller?.bankAccountNumber ||
                !dataSeller?.bankAccountName
              }
              block
              onClick={() => {
                handleFinished(dataSeller)
                setDataSeller({})
              }}
              className="flex-grow-1"
              color="primary"
              testId="transaction-unverified-seller-continue-button"
            >
              Tambah Data
            </CustomButton>
          </div>
        </Form>
      </ModalBody>
    </Modal>
  )
}

export default ModalUnverifSeller
